var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.242 6.177l8.14 6.176 8.139-6.176L8.383 0zM0 17.19l5.852-5.498L0 7.252zM10.912 11.692l5.852 5.499V7.253z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.049 17.899l-5.95-5.59-1.414 1.073a.5.5 0 01-.606 0l-1.414-1.074-5.95 5.59H16.05z"
  })));
}
export default SvgEmailinline;